import React, { useState, useEffect } from "react"
import { useAppCtx } from "lib/state"
import { appTools, cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider"
import { useRenderStyling } from "lib/hooks/useRenderStyling"

export default function SectionHeaderRender({ title, className="" }:{ title:string; className?:string }){

  const { mode, subdomain, getFromRp, getFromMerch, getApiFeedData, getElementConfig }:any = useTemplatePreviewCtx() 

  const headerWrapper = useRenderStyling(cn("mt-3 mb-1 pl-2", className), "styleObj")
  const headerTitle = useRenderStyling("inline text-lg font-bold ml-2 uppercase border-b-4 border-b-solid border-b-neutral-900", "styleObj")

  return (
    <div {...headerWrapper}>
      <h1 {...headerTitle}>{ title }</h1>
    </div>
  )
}